// Загрузка справочников для шапки статистики.
// Вынесено из BlockStat.vue, чтобы шапку можно было переиспользовать
// на дашборде «Инсайты» без копирования запросов.
import axios from 'axios';

export function apiHost() {
  return process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:5001';
}

const post = (path, body) => axios.post(apiHost() + '/api/v1' + path, body);

export function fetchProjects(clientId) {
  return post('/project/get', { clientId: clientId }).then(r => r.data.data || []);
}

export function fetchTokens(clientId, projectId) {
  return post('/token/get', { clientId: clientId, projectId: projectId }).then(r => r.data || []);
}

export function fetchUtmGroups(clientId, projectId) {
  return post('/utmGroup/get', { clientId: clientId, projectId: projectId }).then(r => r.data.data || []);
}

// Возвращает пары [начало, конец] в ISO. Первый элемент ответа — точка отсчёта,
// сама по себе периодом не является, поэтому цикл стартует с 1.
// Последняя пара заканчивается строкой 'сегодня' — так же, как в BlockStat.
export function fetchDatePoints(clientId, projectId, token) {
  return post('/token/getDatePoints', { clientId: clientId, projectId: projectId, token: token })
    .then(r => {
      const data = r.data || [];
      const out = [];
      for (let i = 1; i < data.length; i++) {
        const cur = new Date(data[i].timestamp).toISOString();
        if (i === data.length - 1) { out.push([cur, 'сегодня']); continue; }
        out.push([new Date(data[i - 1].timestamp).toISOString(), cur]);
      }
      return out;
    });
}
